import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useRef, useEffect } from 'react';
import { TEMPORARY_CONSENT_BASE_KEY } from '../utils.js';

function getSessionStorageOrDefault(key, defaultValue) {
  if (typeof window !== "undefined") {
    var stored = window.sessionStorage.getItem(key);
    if (!stored) {
      window.sessionStorage.setItem(key, JSON.stringify(defaultValue));
      return defaultValue;
    }
    return JSON.parse(stored);
  }
}
function useSessionStorage(key, defaultValue) {
  var pollingInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
  var _useState = useState(getSessionStorageOrDefault(key, defaultValue)),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var polling = useRef();
  useEffect(function () {
    if (polling.current) clearInterval(polling.current);
    polling.current = setInterval(function () {
      var curr = getSessionStorageOrDefault(key, defaultValue);
      if (curr !== value) setValue(curr);
    }, pollingInterval);
  }, [value, setValue]);
  useEffect(function () {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);
  return [value, setValue];
}
var useSessionStorageObserver = function useSessionStorageObserver() {
  var _globalThis$window;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    changeSwitch = _useState4[0],
    setChangeSwitch = _useState4[1];
  var _useState5 = useState((globalThis === null || globalThis === void 0 || (_globalThis$window = globalThis.window) === null || _globalThis$window === void 0 ? void 0 : _globalThis$window.sessionStorage) != null ? JSON.stringify(Object.fromEntries(Object.entries(sessionStorage).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key.startsWith(TEMPORARY_CONSENT_BASE_KEY);
    }))) : "{}"),
    _useState6 = _slicedToArray(_useState5, 2),
    sessionStorageString = _useState6[0],
    setSessionStorageString = _useState6[1];
  var registerChange = function registerChange() {
    return setChangeSwitch(function (oldState) {
      return !oldState;
    });
  };
  useEffect(function () {
    var intervalId = setInterval(function () {
      var currentSessionStorageString = JSON.stringify(Object.fromEntries(Object.entries(sessionStorage).filter(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          key = _ref4[0];
        return key.startsWith(TEMPORARY_CONSENT_BASE_KEY);
      })));
      if (currentSessionStorageString === sessionStorageString) return;
      setSessionStorageString(currentSessionStorageString);
      registerChange();
    }, 1000);
    return function () {
      return clearInterval(intervalId);
    };
  }, [registerChange, sessionStorageString, setSessionStorageString]);
  return changeSwitch;
};

export { useSessionStorage, useSessionStorageObserver };
//# sourceMappingURL=useSessionStorage.js.map
